<template>
  <div class="">
    <navbar></navbar>
    <main class="main" role="main">
      <div class="py-5 bg-light">
        <div class="container">
          <router-link to="top">{{$t('ordertop.myhome')}}</router-link> / {{$t('Settingspage.SettingsTop')}}
          <div class="card mt-4">
            <div class="card-body">
              <h5 class="card-title">{{$t('Settingspage.UpdatePassword')}}</h5>
              <h6 class="card-subtitle mb-2 text-muted"></h6>
              <p class="card-text">{{$t('Settingspage.UpdatePsdTips')}}</p>
              <button class="btn btn-facebook" @click="updatePassword">{{$t('Settingspage.UpdateButton')}}</button>
            </div>
          </div>
          <div class="card mt-4">
            <div class="card-body">
              <h5 class="card-title">{{$t('Settingspage.UpdateTwofactauth')}}</h5>
              <h6 class="card-subtitle mb-2 text-muted"></h6>
              <p class="card-text">{{$t('Settingspage.UpdateTwofactauthTips')}}</p>
              <button class="btn btn-facebook" @click="updateTwoFactAuth">{{$t('Settingspage.UpdateButton')}}</button>
            </div>
          </div>
        </div>
      </div>
    </main>
    <copyright></copyright>
    <updatepassword></updatepassword>
    <updatetwofactauth></updatetwofactauth>
  </div>
</template>

<style src="../../../static/css/dashboard.css" />

<script type="text/javascript">
import navbar from './navbar'
import copyright from '../user/copyright'
import updatepassword from './update-password'
import updatetwofactauth from './update-twofactauth'
export default {
  components: { navbar, copyright, updatepassword, updatetwofactauth },
  data: function () {
    return {
    }
  },
  mounted() {
  },
  methods: {
    updatePassword() {
      $('#updatePasswordModal').modal('show')
    },
    updateTwoFactAuth() {
      $('#updateTwoFactAuthModal').modal('show')
    }
  }
}
</script>
<style scoped>
.container{
  min-height:calc(100vh - 256px)
}
</style>



// WEBPACK FOOTER //
// src/components/operator/info.vue